import React, { useState } from 'react'
import { Button, Modal, Image, Input, Dropdown } from 'semantic-ui-react'
import somethingAintRight from '../../assets/somethingAintRight.gif'
import { createNotice } from '../../redux/actions/products'
import { useDispatch } from 'react-redux'

const DEFAULT_KIND = 'incorrect-brand'
const DEFAULT_COMMENT = ''

export const CreateNoticeModal = ({ productId }: any) => {
  const [open, setOpen] = useState(false)
  const [comment, setComment] = useState<string>(DEFAULT_COMMENT)
  const [duplicateProductId, setDuplicateProductId] = useState<number | null>(null)
  const [kind, setKind] = useState<string>(DEFAULT_KIND)

  const dispatch = useDispatch()

  const dropDownOptions = [
    {
      key: 'discontinued',
      text: 'discontinued',
      value: 'discontinued',
    },
    {
      key: 'incorrect-brand',
      text: 'incorrect-brand',
      value: 'incorrect-brand',
    },
    {
      key: 'duplicate',
      text: 'duplicate',
      value: 'duplicate',
    },
  ]

  const reset = () => {
    setKind(DEFAULT_KIND)
    setComment(DEFAULT_COMMENT)
  }

  const onSubmit = () => {
    dispatch(
      createNotice({
        notice: {
          product_id: productId,
          kind: kind,
          data: {
            active_product_id: kind === 'duplicate' ? duplicateProductId : undefined,
            comment: kind !== 'duplicate' ? comment : undefined,
          },
        },
      })
    )
    reset()
    setOpen(false)
  }

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      style={{
        margin: 'auto 15px',
      }}
      trigger={
        <Button color="yellow">Mark Product {productId.toString()} As Needing Attention</Button>
      }
    >
      <Modal.Header>Create A Notice For This Product</Modal.Header>
      <Modal.Content image>
        <Image size="small" src={somethingAintRight} />
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <Input fluid disabled value={productId} />
          <Dropdown
            fluid
            placeholder="Type.."
            selection
            options={dropDownOptions}
            onChange={(_e, data) => {
              if (data.value) {
                const value: string = data.value.toString()
                _e.preventDefault()
                setKind(value)
              }
            }}
            value={kind}
          />
          {kind !== 'duplicate' ? (
            <Input
              fluid
              placeholder="Comment.."
              onChange={(_e, data) => {
                setComment(data.value)
              }}
              value={comment}
            />
          ) : (
            <Input
              fluid
              type="number"
              placeholder="ID of duplicate product"
              onChange={(_e, data) => {
                setDuplicateProductId(parseInt(data.value))
              }}
              value={duplicateProductId}
            />
          )}
          <Button
            primary
            onClick={(event, data) => {
              event.preventDefault()
              onSubmit()
            }}
          >
            Create Notice
          </Button>
        </div>
      </Modal.Content>
    </Modal>
  )
}
